<template>
  <div>
    <el-card>
      <search-form ref="searchForm" :tabData="tabData" labelWidth="120px" :topVisible="true"
        :searchFormData="searchFormData" @search="search" @tabChange="tabChange">
        <template #topBtn>
          <el-button class="marginRight20" type="primary" size="small" @click="handleExport">{{ $t('button.orderExport')
          }}</el-button>
          <div class="customAmount"><span>{{ `${$t('form.after_sales_order.totalRefundAmount')}: ${total_refund || 0}` }}</span></div>
          <div class="customAmount"><span>{{ `${$t('form.after_sales_order.totalReturnAmount')}: ${total_return || 0}` }}</span></div>
          <div class="customAmount"><span>{{ `${$t('form.after_sales_order.totalReductAmount')}: ${total_reduct || 0}` }}</span></div>
        </template>
      </search-form>
      <create-table :operationColWidth="135" :autoWidth="true"
        @handleNewTab="handleNewTab($event, 'ordersManagerAfterSalesOrdersDetail')" :operateVisible="operateVisible"
        ref="createTable" :loading="loading" :btnType="[]" :total_count="pageData.total_count ? pageData.total_count : 0"
        :current_page.sync="pageData.page" :papeSize.sync="pageData.per_page" @selectionChange="selectionChange"
        :topButtonVisible="true" :tableData="tableData" :tableDataItem="tableDataItem" @operate="handleClick"
        :pageVisible="true" :pageData="pageData" :checkBoxVisible="dropDataItem.length > 0" @handleSort="handleSort"
        @forwardToPage="forwardToPage" :excludes="tableDataExcludes">
        <template #topButton>
          <span v-if="dropDataItem.length > 0" class="marginRight20 spanminWith">{{
            `${$t('text.selected')}：${selectionData.length}` }}</span>
          <allButton :buttonDisabled="selectionData.length < 1" :buttonDataItem="dropDataItem" class="marginRight20"
            @chooseDropItem="chooseDropItem"></allButton>
        </template>
        <template #rightBtn="scope">
          <el-button class="margintop10" :class="item.action === 'view' ? 'operate_view' : ''"
            v-for="(item, index) in scope.row.member_actions.default_actions" :key="'default_actions' + index"
            :type="item.type && item.type === 'warn' ? 'danger' : 'primary'" size="mini"
            @click="handleClick(item, scope.row)">{{ item.name }}</el-button>
          <el-button class="margintop10" v-for="(item, index) in scope.row.member_actions.custom_actions"
            :key="'custom_actions' + index" :type="item.type && item.type === 'warn' ? 'danger' : 'primary'" size="mini"
            @click="handleCusClick(item)">{{ item.name }}</el-button>
        </template>
      </create-table>
    </el-card>
    <router-view />
    <dialogEffect v-if="dialogVisible" :dialogVisible.sync="dialogVisible" :data="dialogData"
      @doNextConfirm="doNextConfirm" :buttonText="$t('button.approve')"></dialogEffect>
    <menuBadgeRefreshDialog menuBadgeKey="after_sales_order" @confirm="() => search({})" />
  </div>
</template>

<script>
import { getAfterSaleOrderSetup, getAfterSaleOrderQueryList, getOrderAfterSalesReport } from '@/services/order'

// import _ from 'lodash'
// import loading from '@/utils/loading.json'
import jsonData from './jsonData.js'
import allButton from '@/components/allButton'
import searchForm from '@/components/searchForm'
import createTable from '@/components/createTable'
import dialogEffect from '@/components/dialogEffect'
import menuBadgeRefreshDialog from '@/components/menuBadgeRefreshDialog'
import { mixin } from '@/mixins/mixin'
export default {
  name: 'managerUserOrders',
  mixins: [mixin],
  components: {
    searchForm,
    createTable,
    allButton,
    dialogEffect,
    menuBadgeRefreshDialog
  },
  data () {
    return {
      tableDataItem: jsonData.tableDataItem,
      total_refund: 0,
      total_return: 0,
      total_reduct: 0
    }
  },
  watch: {
    $route (to, from) {
      // console.log(from)
      if (from.name === 'managerAfterSalesOrdersView') {
        this.$nextTick(() => {
          this.search()
          this.$refs.createTable.$refs.table.doLayout()
        })
      }
    }
  },
  created () {
    if (this.appName.includes('wholesale')) {
      this.searchExcludes = this.searchExcludes.concat(['Delivery Zone', {
        name: 'Submitted By',
        value: 'Host'
      }, 'Buddy Name', 'Buddy Phone Number'])
      this.tabExcludes = this.tabExcludes.concat(['pending_host', 'host_rejected'])
      this.batchExcludes = this.batchExcludes.concat(['Batch Refunded'])
      this.tableDataExcludes = this.tableDataExcludes.concat(['Buddy Name'])
      this.tableDataItem = this.tableDataItem.filter(item => !(item.exclude && item.exclude.includes('wholesale')))
    }
    this.queryData(getAfterSaleOrderSetup)
  },
  activated () {
    if (this.isActive) this.queryData(getAfterSaleOrderSetup)
    this.isActive = true
  },
  methods: {
    async forwardToPage (data, name) {
      if (name === 'user_order') {
        this.$router.push({
          name: 'ordersManagerUserOrdersDetail',
          params: {
            id: data.id
          }
        })
      }
      if (name === 'shop') {
        this.$router.push({
          name: 'shopsManagerDetail',
          params: {
            id: data.id
          }
        })
      }
      if (name === 'product_info') {
        this.$router.push({
          name: 'goodsManagerProductDetail',
          params: {
            id: data.id
          }
        })
      }
      if (name === 'user') {
        this.$router.push({
          name: 'memberDetail',
          params: {
            id: data.id
          }
        })
      }
      if (name === 'host') {
        this.$router.push({
          name: 'buddyManagerBuddyDetail',
          params: {
            id: data.id
          }
        })
      }
    },
    // 点击操作按钮
    async handleClick (type, data) {
      this.$router.push({
        name: 'ordersManagerAfterSalesOrdersDetail',
        params: {
          id: data.id.value
        }
      })
    },
    // 查询
    search (data) {
      if (data) this.searchData = data
      const { page, per_page } = this.pageData
      const scope = this.searchData.scope
      if (scope !== 'refunded') {
        // this.tableDataItem = this.tableDataItem.filter(item => !(item.prop === 'refund_no'))
        this.tableDataItem = jsonData.tableDataItem.filter(item => !(item.prop === 'refund_no'))
      } else {
        this.tableDataItem = jsonData.tableDataItem
      }
      Object.assign(this.searchData, { page, per_page })
      this.loading = true
      getAfterSaleOrderQueryList(this.searchData).then(res => {
        if (res.data) {
          this.tableData = res.data.objects
          this.total_refund = res.data.total_refund
          this.total_return = res.data.total_return
          this.total_reduct = res.data.total_reduct
          this.tabData = this.excludeScopes(this.tabExcludes, res.data.scopes, 'value')
          Object.assign(this.pageData, res.data.pagination)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handleExport () {
      this.$refs.searchForm.commonOperate(getOrderAfterSalesReport, (data) => {
        this.$router.push({
          name: 'afterSalesOrdersDownloadCenter',
          params: { data }
        })
      }, this)
    }
  }
}
</script>

<style lang="scss" scope>
.customAmount {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
  font-size: 14px;
  color: #303133;
  font-weight: 500;
}
</style>
